// extracted by mini-css-extract-plugin
module.exports = {"cls1":"styleHelpers-fontSizeDefault_cls1__2JIkb","cls2":"styleHelpers-fontSizeDefault_cls2__14zSb styleHelpers-fontSizeDefault_cls1__2JIkb"};